export default __webpack_public_path__ + "static/media/Sorbetto.e99d4397.jpg";